import { SVGProps } from 'react';

const CloudCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m17 15-5.5 5.5L9 18m-4-.257A7 7 0 1 1 15.71 10h1.79a4.5 4.5 0 0 1 1.5 8.742"
    />
  </svg>
);
export default CloudCheck;
